var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill-rule: evenodd;\n      }\n\n      .st0, .st1 {\n        fill: #f7f7f7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.67,373.33c-5.89,0-10.67,4.78-10.67,10.67s4.78,10.67,10.67,10.67h106.67c5.89,0,10.67-4.78,10.67-10.67s-4.78-10.67-10.67-10.67h-106.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.27,54.94c-27.13-21.42-65.41-21.42-92.53,0l-138.67,109.47c-17.94,14.16-28.4,35.75-28.4,58.6v171.65c0,41.24,33.43,74.67,74.67,74.67h277.33c41.24,0,74.67-33.43,74.67-74.67v-171.65c0-22.85-10.46-44.44-28.4-58.6l-138.67-109.47ZM222.95,71.68c19.38-15.3,46.72-15.3,66.09,0l138.67,109.47c12.81,10.11,20.29,25.54,20.29,41.86v171.65c0,29.45-23.88,53.33-53.33,53.33H117.33c-29.46,0-53.33-23.88-53.33-53.33v-171.65c0-16.32,7.47-31.75,20.29-41.86l138.67-109.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fcd6818f5c422b4faa69d77d8d49dd7c.svg";
export { ForwardRef as ReactComponent };